export const translations = {
  pl: {
    brand: "Żywiąca Polska",
    slogan: "Rolnicy żywią Polskę. Polska chroni rolników.",
    langName: "Polski",
    demo: "Dane demonstracyjne",
    pilotBanner: "Platforma w fazie pilotażu. Wszystkie dane demonstracyjne są fikcyjne i wyraźnie oznaczone.",
    nav: {
      mission: "Misja", how: "Jak to działa", serve: "Kogo wspieramy", zeroRot: "Zero marnowania",
      forFarmers: "Dla rolników", forInstitutions: "Dla instytucji",
      protection: "Ochrona rolnika", institutional: "Żywność instytucjonalna", circular: "Gospodarka obiegu",
      soil: "Gleba i plan", governance: "Ład", investors: "Inwestorzy", contact: "Kontakt",
      kwitnie: "Polska Kwitnie",
      rescue: "Ratunek dla Plonu", login: "Zaloguj się", register: "Załóż konto", app: "Panel",
      founder: "Założyciel — Konrad Kwiatkowski",
    },
    cta: {
      registerCrop: "Zgłoś plon", registerDemand: "Zgłoś zapotrzebowanie",
      becomePartner: "Zostań partnerem", viewModel: "Zobacz model", seeHow: "Zobacz, jak działa system",
      submit: "Wyślij", save: "Zapisz", cancel: "Anuluj", create: "Utwórz", update: "Zaktualizuj",
      approve: "Zatwierdź", export: "Eksport CSV", search: "Szukaj", filter: "Filtruj", close: "Zamknij",
      viewAll: "Zobacz wszystko", back: "Wróć",
    },
    home: {
      heroTitle: "Polscy rolnicy żywią Polskę.",
      heroSub: "Łączymy plony z dziećmi, szpitalami, seniorami, wojskiem i pracownikami — zanim dobra polska żywność zostanie zmarnowana.",
      zeroRotTitle: "Zasada Zero Marnowania",
      zeroRot: "Żaden bezpieczny polski owoc ani warzywo nie powinny zgnić z powodu braku zorganizowanej i ekonomicznie uzasadnionej drogi na rynek.",
      priorityTitle: "Kogo karmimy w pierwszej kolejności",
      doctrine: "Technologia porządkuje. Ludzie decydują. Każda transakcja pozostaje identyfikowalna.",
      flowTitle: "Od gospodarstwa do instytucji — obieg zamknięty",
      metricsTitle: "Wskaźniki misji",
    },
    priorities: {
      children: "Dzieci", hospitals: "Szpitale i pacjenci", seniors: "Opieka senioralna",
      military: "Wojsko", workers: "Pracownicy",
    },
    flow: ["Gospodarstwo", "Centrum regionalne", "Instytucje", "Przetwórstwo", "Odzysk biologiczny", "Gleba"],
    roles: {
      farmer: "Rolnik", buyer: "Nabywca instytucjonalny", processor: "Przetwórca",
      logistics: "Logistyka", coordinator: "Koordynator regionalny", quality: "Kontrola jakości",
      agronomist: "Agronom", finance: "Finanse", investor: "Inwestor",
      beekeeper: "Pszczelarz",
      admin: "Administrator", super_admin: "Super administrator",
    },
    dashboard: {
      welcome: "Witaj", summary: "Podsumowanie", myCrops: "Moje plony", myDemand: "Moje zapotrzebowanie",
      capacity: "Moce przetwórcze", rescue: "Ratunek dla Plonu", matching: "Dopasowania",
      settlements: "Rozliczenia", proposals: "Propozycje", investor: "Sala inwestorska",
      admin: "Administracja", users: "Użytkownicy", leads: "CRM / Zgłoszenia", audit: "Dziennik audytu",
      settings: "Ustawienia", flags: "Przełączniki funkcji", logistics: "Logistyka",
      recovery: "Odzysk biologiczny", disputes: "Spory", impact: "Wpływ", governance: "Ład i uczciwość",
      approvals: "Zatwierdzenia", soil: "Gleba i plan", brief: "Truskawka 2027",
      pollination: "Zapylanie", alerts: "Alerty o zabiegach", habitat: "Siedliska", honey: "Miód Żywiącej Polski",
      logout: "Wyloguj", overview: "Przegląd",
    },
    crop: {
      title: "Rejestracja plonu", product: "Produkt", variety: "Odmiana", category: "Kategoria",
      quantity: "Oczekiwana ilość", unit: "Jednostka", harvestStart: "Początek zbiorów",
      harvestEnd: "Koniec zbiorów", minPrice: "Minimalna opłacalna cena / jedn.", prefPrice: "Cena preferowana",
      offer: "Najlepsza oferta", location: "Lokalizacja", region: "Region", notes: "Uwagi",
      refrigeration: "Wymaga chłodzenia", transport: "Wymaga transportu", status: "Status",
      remaining: "Pozostało (ryzyko)", matched: "Dopasowano", freshEst: "Świeże (szac.)",
      procEst: "Do przetwórstwa (szac.)",
    },
    demand: {
      title: "Rejestracja zapotrzebowania", grade: "Klasa", maxPrice: "Cena maks.", targetPrice: "Cena docelowa",
      deliveryDate: "Data dostawy", preparation: "Przygotowanie", packaging: "Opakowanie",
      location: "Miejsce dostawy",
    },
    settlement: {
      gross: "Cena brutto nabywcy", quantity: "Ilość przyjęta", grossTotal: "Wartość brutto",
      deductions: "Potrącenia", payment: "Do wypłaty rolnikowi", addAdjustment: "Dodaj potrącenie",
      type: "Rodzaj", amount: "Kwota", reason: "Powód (wymagany)",
      transparency: "Każde potrącenie ma kwotę, powód, osobę odpowiedzialną i znacznik czasu.",
    },
    auth: {
      loginTitle: "Zaloguj się", registerTitle: "Załóż konto", email: "E-mail", password: "Hasło",
      name: "Imię i nazwisko / nazwa", org: "Nazwa organizacji", role: "Rola", noAccount: "Nie masz konta?",
      haveAccount: "Masz już konto?", demoAccounts: "Konta demonstracyjne (podgląd)",
    },
    footer: {
      tagline: "Farmer-rooted food security for Poland.",
      legal: "Informacje prawne", privacy: "Polityka prywatności", terms: "Regulamin",
      dpn: "Informacja o przetwarzaniu danych", cookies: "Informacja o cookies",
      disclaimer: "Wszystkie struktury operacyjne, spółdzielcze, zamówieniowe, żywnościowe, energetyczne i finansowe wymagają weryfikacji przez wykwalifikowanych polskich i unijnych specjalistów przed wdrożeniem.",
    },
    empty: "Brak danych.",
  },
  en: {
    brand: "Żywiąca Polska",
    slogan: "Farmers feed Poland. Poland protects its farmers.",
    langName: "English",
    demo: "Demo data",
    pilotBanner: "Platform in pilot development. All demonstration records are fictional and clearly labelled.",
    nav: {
      mission: "Mission", how: "How it works", serve: "Who we serve", zeroRot: "Zero-Rot",
      forFarmers: "For farmers", forInstitutions: "For institutions",
      protection: "Farmer protection", institutional: "Institutional food", circular: "Circular economy",
      soil: "Soil & planning", governance: "Governance", investors: "Investors", contact: "Contact",
      rescue: "Harvest Rescue", login: "Sign in", register: "Create account", app: "Dashboard",
      founder: "Founder — Konrad Kwiatkowski",
    },
    cta: {
      registerCrop: "Register a crop", registerDemand: "Register demand",
      becomePartner: "Become a partner", viewModel: "View the model", seeHow: "See how it works",
      submit: "Submit", save: "Save", cancel: "Cancel", create: "Create", update: "Update",
      approve: "Approve", export: "Export CSV", search: "Search", filter: "Filter", close: "Close",
      viewAll: "View all", back: "Back",
    },
    home: {
      heroTitle: "Polish farmers feed Poland.",
      heroSub: "We connect crops with children, hospitals, seniors, the military and workers — before good Polish food goes to waste.",
      zeroRotTitle: "The Zero-Rot Principle",
      zeroRot: "No safe Polish-grown fruit or vegetable should rot because there was no organized, economically viable route to market.",
      priorityTitle: "Who we feed first",
      doctrine: "Technology organizes. People decide. Every transaction remains traceable.",
      flowTitle: "Farm to institution — a circular flow",
      metricsTitle: "Mission indicators",
    },
    priorities: {
      children: "Children", hospitals: "Hospitals & patients", seniors: "Senior care",
      military: "Military", workers: "Workers",
    },
    flow: ["Farm", "Regional Center", "Institutions", "Processing", "Biological Recovery", "Soil"],
    roles: {
      farmer: "Farmer", buyer: "Institutional buyer", processor: "Processor",
      logistics: "Logistics", coordinator: "Regional coordinator", quality: "Quality reviewer",
      agronomist: "Agronomist", finance: "Finance", investor: "Investor",
      beekeeper: "Beekeeper",
      admin: "Administrator", super_admin: "Super administrator",
    },
    dashboard: {
      welcome: "Welcome", summary: "Summary", myCrops: "My crops", myDemand: "My demand",
      capacity: "Processing capacity", rescue: "Harvest Rescue", matching: "Matching",
      settlements: "Settlements", proposals: "Proposals", investor: "Investor room",
      admin: "Administration", users: "Users", leads: "CRM / Leads", audit: "Audit log",
      settings: "Settings", flags: "Feature flags", logistics: "Logistics",
      recovery: "Biological recovery", disputes: "Disputes", impact: "Impact", governance: "Governance & integrity",
      approvals: "Approvals", soil: "Soil & planning", brief: "Truskawka 2027",
      pollination: "Pollination", alerts: "Treatment alerts", habitat: "Habitat", honey: "Miód Żywiącej Polski",
      logout: "Log out", overview: "Overview",
    },
    crop: {
      title: "Crop registration", product: "Product", variety: "Variety", category: "Category",
      quantity: "Expected quantity", unit: "Unit", harvestStart: "Harvest start",
      harvestEnd: "Harvest end", minPrice: "Minimum viable price / unit", prefPrice: "Preferred price",
      offer: "Best offer", location: "Location", region: "Region", notes: "Notes",
      refrigeration: "Refrigeration required", transport: "Transport required", status: "Status",
      remaining: "Remaining (at risk)", matched: "Matched", freshEst: "Fresh (est.)",
      procEst: "Processing (est.)",
    },
    demand: {
      title: "Demand registration", grade: "Grade", maxPrice: "Max price", targetPrice: "Target price",
      deliveryDate: "Delivery date", preparation: "Preparation", packaging: "Packaging",
      location: "Delivery location",
    },
    settlement: {
      gross: "Buyer gross price", quantity: "Quantity accepted", grossTotal: "Gross total",
      deductions: "Deductions", payment: "Payable to farmer", addAdjustment: "Add adjustment",
      type: "Type", amount: "Amount", reason: "Reason (required)",
      transparency: "Every adjustment has an amount, reason, responsible user and timestamp.",
    },
    auth: {
      loginTitle: "Sign in", registerTitle: "Create account", email: "Email", password: "Password",
      name: "Full name / organization", org: "Organization name", role: "Role", noAccount: "No account?",
      haveAccount: "Already have an account?", demoAccounts: "Demo accounts (preview)",
    },
    footer: {
      tagline: "Farmer-rooted food security for Poland.",
      legal: "Legal", privacy: "Privacy Policy", terms: "Terms of Use",
      dpn: "Data Processing Notice", cookies: "Cookie Notice",
      disclaimer: "All operational, cooperative, procurement, food-safety, energy and financial structures require review by qualified Polish and EU professionals before implementation.",
    },
    empty: "No data.",
  },
};
